"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalAccountService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.LegacyPortalAccountService
 */
exports.LegacyPortalAccountService = {
    typeName: "spwn.account.v1.LegacyPortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.SignInWithFanyId
         */
        signInWithFanyId: {
            name: "SignInWithFanyId",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceSignInWithFanyIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceSignInWithFanyIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.LinkWithFanyId
         */
        linkWithFanyId: {
            name: "LinkWithFanyId",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceLinkWithFanyIdRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceLinkWithFanyIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * start.gg 連携の開始。CSRF 用の state を発行して HttpOnly cookie にセットし、
         * 認可画面の URL を返す。cookie は ExchangeStartggCode でサーバ側照合する。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.StartStartggLink
         */
        startStartggLink: {
            name: "StartStartggLink",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceStartStartggLinkRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceStartStartggLinkResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * start.gg OAuth: portal で受け取った authorization code を access token に交換し、
         * 連携した start.gg ユーザーの id / gamerTag を返す。state cookie と照合してから交換する。
         * トークンはサーバに保持しない（連携状態の永続化は呼び出し側の責務）。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.ExchangeStartggCode
         */
        exchangeStartggCode: {
            name: "ExchangeStartggCode",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceExchangeStartggCodeRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceExchangeStartggCodeResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * start.gg: 指定した start.gg ユーザーが対象イベントに entry 済みかを返す。
         * 登録直後の反映を優先するため NO_SIDE_EFFECTS は付けない（GET キャッシュを避け POST で毎回フレッシュ）。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.GetStartggEntryStatus
         */
        getStartggEntryStatus: {
            name: "GetStartggEntryStatus",
            I: legacy_portal_service_pb_1.LegacyPortalAccountServiceGetStartggEntryStatusRequest,
            O: legacy_portal_service_pb_1.LegacyPortalAccountServiceGetStartggEntryStatusResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map